import { atom } from 'ximple/atoms';
import { LocalStorageKey, getDynamicStorageKey } from '../localstorage';
import { VERSION } from '@repo/widget-env/__autogen/env';
import { OctoCart } from '@repo/types';
import { OctoCartEvents, reduceOctoCartState } from './octoCart.reducer';

type State = OctoCart;

export const octoCartAtom = atom<State, OctoCartEvents>({
    initialValue: {
        isDirty: false,
    },
    persistKey: getDynamicStorageKey(LocalStorageKey.BILBERRY_OCTO_CART),
    appVersion: VERSION,
    update: updateCartAtom,
});

function updateCartAtom(state: OctoCart, action: OctoCartEvents) {
    const result = reduceOctoCartState(state, action);

    // TODO: support for dispatching custom events for octo cart
    //dispatchWidgetEvents(action, state);

    return result;
}
